import NinetyTwoToOneTwoTwo from "./NinetyTwoToOneTwoTwo";
import OneEightFourToTwoOneThree from "./OneEightFourToTwoOneThree";
import OneFiveThreeToOneEightThree from "./OneFiveThreeToOneEightThree";
import OneToThirty from "./OneToThirty";
import SixtyTwoToNinetyOne from "./SixtyTwoToNinetyOne";
import ThreeZeroSixToThreeThreeFive from "./ThreeZeroSixToThreeThreeFive";
import ThrityOneToSixtyOne from "./ThrityOneToSixtyOne";
import TwoFourFiveToTwoSevenFour from "./TwoFourFiveToTwoSevenFour";
import TwoOneFourToTwoFourFour from "./TwoOneFourToTwoFourFour";
import TwoSevenFiveToThreeZeroFive from "./TwoSevenFiveToThreeZeroFive";

export const BIBLE_TABS_DATA = [
  {
    label: "Day 1-30 ความมหัศจรรย์เหนือบรรยาย",
    component: <OneToThirty />,
  },
  {
    label: "Day 31-61 หนังสือเดินทางสู่สวรรค์",
    component: <ThrityOneToSixtyOne />,
  },
  {
    label: "Day 62-91 ถวายชีวิตทั้งหมด",
    component: <SixtyTwoToNinetyOne />,
  },
  {
    label: "Day 92-122 เราจะอยู่กับเจ้า",
    component: <NinetyTwoToOneTwoTwo />,
  },
  {
    label: "Day 123-152 โลกที่แตกต่าง",
    component: <NinetyTwoToOneTwoTwo />,
  },
  {
    label: "Day 153-183 โลกที่แตกต่าง",
    component: <OneFiveThreeToOneEightThree />,
  },
  {
    label: "Day 184-213 พระเจ้าผู้ทรงกระทำในสิ่งที่เป็นไปไม่ได้",
    component: <OneEightFourToTwoOneThree />,
  },
  {
    label: "Day 214-244 ก้าวสูงขึ้นไป",
    component: <TwoOneFourToTwoFourFour />,
  },
  {
    label: "Day 245-274 เมื่อความรักครอบครอง",
    component: <TwoFourFiveToTwoSevenFour />,
  },
  {
    label: "Day 275-305 ชีวิตที่เต็มไปด้วย...",
    component: <TwoSevenFiveToThreeZeroFive />,
  },
  {
    label: "Day 306-335 ไม่ใช่เป็นความลึกลับ",
    component: <ThreeZeroSixToThreeThreeFive />,
  },
  {
    label: "Day 336-365 ตลอดไปเป็นนิตย์",
    component: <ThreeZeroSixToThreeThreeFive />,
  },
];
